import * as types from "../actionTypes/snackbarActionTypes";
import * as eventTypes from "actions/eventTypes";
import i18next from "i18next";

export function showInfo(msg, autoDismiss = true, refreshPage = false) {
  return { type: types.SHOW_SNACKBAR_INFO, payload: { msg, autoDismiss, refreshPage } };
}

export function showError(msg, correlationId) {
  return { type: types.SHOW_SNACKBAR_ERROR, payload: msg, correlationId: correlationId };
}

export function showWarning(msg, correlationId) {
  return { type: types.SHOW_SNACKBAR_WARNING, payload: msg, correlationId: correlationId };
}

export function clearSnackbar() {
  return { type: types.CLEAR_SNACKBAR };
}

export function showEvent(event) {
  const eventTitle = i18next.t("Notifications." + event.eventType, { data: event.eventBody });

  if (!event.ok) {
    let description = "";

    if (event.eventBody.code) description = i18next.t(event.eventBody.code, { data: event.eventBody.data });
    else description = event.eventBody.message;

    let correlationId = "";

    if (event.eventType.indexOf(eventTypes.COMMAND_VALIDATION_ERROR) === -1) {
      correlationId = event.correlationId;
    }

    if (event.eventType.indexOf(eventTypes.COMMAND_EXECUTION_WARNING)) {
      return showWarning(eventTitle + description, event.correlationId);
    }

    if (event.eventType.indexOf(eventTypes.COMMAND_EXECUTION_INFORMATION)) {
      return showInfo(eventTitle + description, false, false);
    }

    return showError(eventTitle + description, correlationId);
  }

  return showInfo(eventTitle);
}
